export default __webpack_public_path__ + "static/media/icone-form.4eb5f567.svg";